import { CompletedFilterLabel } from '@/common/constants/filter';

// 할일 완료 표시 기준 옵션 타입 정의
export type TodoCompleteViewOption = 'week' | 'two_week' | 'month';

// 메뉴 옵션 정보 인터페이스
export interface MenuOptionInfo {
    value: TodoCompleteViewOption;
    label: string;
}

// 완료된 투두 보기 옵션 정의
export const TODO_COMPLETE_VIEW_OPTIONS: MenuOptionInfo[] = [
    {
        value: 'week',
        label: CompletedFilterLabel.WEEK,
    },
    {
        value: 'two_week',
        label: CompletedFilterLabel.TWO_WEEK,
    },
    {
        value: 'month',
        label: CompletedFilterLabel.MONTH,
    },
];
